export const projectsLabel = "Projects";
export const projectName = "Project Name";
export const addProjectLabel = "Add Project";
export const editProjectsLabel = "Edit Project";
export const locationLabel = "Location";
export const projectLabel = "Project";
export const projectKey = "project_name";
export const locationKey = "project_location";
